import { NgModule } from '@angular/core';
import { NumericExpressionDirective } from './numeric-expression.directive';
import { NumericPatternValidatorDirective } from './numeric-pattern-validator.directive';

@NgModule({
  declarations: [NumericExpressionDirective, NumericPatternValidatorDirective],
  exports: [NumericExpressionDirective, NumericPatternValidatorDirective],
})
export class NumericExpressionModule {}
